
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/okta-vs-entra-id",
      function () {
        return require("private-next-pages/compare/okta-vs-entra-id.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/okta-vs-entra-id"])
      });
    }
  